import { createAsyncThunk } from '@reduxjs/toolkit'
import { SippApi } from '../../../services/SippExpress'

// SIPP-844: fire `free_plan_selected` to Customer.io when a user clicks
// "Stay on Free" on the Recommendations tab. Mirrors the
// `fireWqiReportCompletedAsync` pattern — the backend forwards to CIO and
// owns the canonical event name.

interface FireFreePlanSelectedParams {
  userId: string
  wqiScore: number | null
  waterSafetyStatus: string
}

export const fireFreePlanSelectedAsync = createAsyncThunk<
  void,
  FireFreePlanSelectedParams
>(
  'user/fireFreePlanSelected',
  async ({ userId, wqiScore, waterSafetyStatus }, { rejectWithValue }) => {
    try {
      await SippApi.create.freePlanSelected(userId, {
        wqiScore,
        waterSafetyStatus,
      })
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || { message: 'Unexpected error occurred' }
      )
    }
  }
)
